import type {FC} from 'react';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const AddStepFromReportLink: FC<Props> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="text-primary-1 text-sm underline hover:opacity-70 disabled:opacity-40 disabled:cursor-not-allowed transition-opacity"
    >
      体験記から選考予定を追加
    </button>
  );
};
